import axios from "axios";
import {hostWithPrefix} from "../../Features/Constructor/common/ApiCommon";

export function getStationById(stationId) {
    return axios({
        url: 'http://' + hostWithPrefix +
            "/stations-datasources/" + stationId,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        responseType: 'json',
    })
}

export function getDatasourceById(datasourceId) {
    return axios({
        url: 'http://' + hostWithPrefix +
            "/datasources/" + datasourceId,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        responseType: 'json',
    })
}

export function getStationByDatasourceId(datasourceId) {
    return axios({
        url: 'http://' + hostWithPrefix +
            "/station-by-datasource-id/" + datasourceId,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        responseType: 'json',
    })
}